import { TextField, TextFieldProps } from '@mui/material';
import { ChangeEvent } from 'react';
import { SnowflakeFormData } from './SnowflakeFormDrawerContent';

interface SnowflakeFormTextInputsProps {
  formData: SnowflakeFormData;
  handleTextInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  isLoading: boolean;
}

export const SnowflakeFormTextInputs = ({
  formData,
  handleTextInputChange,
  isLoading,
}: SnowflakeFormTextInputsProps) => {
  const commonTextFieldProps: Partial<TextFieldProps> = {
    onChange: handleTextInputChange,
    disabled: isLoading,
    variant: 'outlined',
    fullWidth: true,
  };

  return (
    <>
      <TextField
        required
        label="Account Name"
        name="accountName"
        placeholder="Enter Account Name"
        value={formData.accountName}
        {...commonTextFieldProps}
      />
      <TextField
        required
        label="Database"
        name="database"
        placeholder="Enter Database"
        value={formData.database}
        {...commonTextFieldProps}
      />
      <TextField
        required
        label="Schema"
        name="schema"
        placeholder="Enter Schema"
        value={formData.schema}
        {...commonTextFieldProps}
      />
      <TextField
        required
        label="Warehouse"
        name="warehouse"
        placeholder="Enter Warehouse"
        value={formData.warehouse}
        {...commonTextFieldProps}
      />
      <TextField
        required
        label="Table"
        name="table"
        placeholder="Enter Table"
        value={formData.table.value}
        error={!!formData.table.errorMessage}
        helperText={formData.table.errorMessage ?? undefined}
        {...commonTextFieldProps}
      />
      <TextField
        label="User"
        name="user"
        placeholder="Enter User"
        value={formData.user}
        {...commonTextFieldProps}
      />
      <TextField
        label="Role"
        name="role"
        placeholder="Enter Role"
        value={formData.role}
        {...commonTextFieldProps}
      />
    </>
  );
};
